export class ChangeEmailRequest {
    sessionToken: string = '';
    newEmail: string = '';
    confirmPassword: string = '';
  }